export const FIND_REPORTS_REQUEST = 'FIND_REPORTS_REQUEST';

export const findReportsRequest = ({
     filter = [],
     sorting = { field: 'createdAt', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_REPORTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
